export enum EDropCategory {
  Assigned = 'assigned',
  Unassigned = 'unassigned',
  Category = 'category',
  Section = 'section',
}

export enum ECategoryType {
  Standard = 'Standard',
  MultiNumeric = 'MultiNumeric',
  SubmodelView = 'SubmodelView',
}

export enum EFeatureStatus {
  Active = 'Active',
  InActive = 'InActive',
}

export enum EFeatureFamilyType {
  String = 'String',
  Numeric = 'Numeric',
  Feature = 'Feature',
}

export const FeatureTypeFilters = [
  { value: 'String', label: 'String' },
  { value: 'Numeric', label: 'Numeric' },
  { value: 'Feature', label: 'Feature' },
];

export enum ECategoryErrorType {
  INVALID_DRAG_DROP = 'INVALID_DRAG_DROP',
  MULTI_NUMERIC_WARNING = 'MULTI_NUMERIC_WARNING',
}
